import { render, staticRenderFns } from "./tournaments.vue?vue&type=template&id=48529610&scoped=true&"
import script from "./tournaments.vue?vue&type=script&lang=js&"
export * from "./tournaments.vue?vue&type=script&lang=js&"
import style0 from "./tournaments.vue?vue&type=style&index=0&id=48529610&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48529610",
  null
  
)

export default component.exports